import { colors } from '@mui/material';

export const styles = {
	root: {},
	success: {
		backgroundColor: colors.green[600],
		color: '#FFFFFF'
	},
	error: {
		backgroundColor: 'text.light_red',
		color: '#FFFFFF'
	},
	info: {
		backgroundColor: colors.blue[600],
		color: '#FFFFFF'
	},
	warning: {
		backgroundColor: colors.amber[600],
		color: '#FFFFFF'
	}
};
